import { render, staticRenderFns } from "./SalesHistoryList.vue?vue&type=template&id=6c31f2cf&scoped=true&"
import script from "./SalesHistoryList.vue?vue&type=script&lang=js&"
export * from "./SalesHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./SalesHistoryList.vue?vue&type=style&index=0&id=6c31f2cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c31f2cf",
  null
  
)

export default component.exports